import CustomModalHeader from 'components/Custom/CustomModalHeader'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { FormGroup, Input, Modal, ModalBody } from 'reactstrap'
import { giveCompletionFeedback } from 'store/Course/actions'

function CompletionFeedbackModal({ showModal, setShowModal, courseId }) {
  const dispatch = useDispatch()

  const [showFeedbackInput, setShowFeedbackInput] = useState(false)
  const [feedback, setFeedback] = useState('')
  const [errorMessage, setErrorMessage] = useState(false)

  return (
    <Modal
      isOpen={showModal}
      toggle={() => setShowModal(false)}
      size='md'
      centered
      scrollable
    >
      <CustomModalHeader
        title={'Course Feedback'}
        toggle={() => {
          setShowModal(false)
        }}
      />
      <ModalBody className='scrollbar justify-content-center text-center'>
        {!showFeedbackInput ? (
          <p>Did you find the training easy to understand?</p>
        ) : (
          <p>Help us improve!</p>
        )}

        {errorMessage && (
          <p className='text-danger'>
            We’d love to hear your thoughts to make this training clearer.
          </p>
        )}
        {showFeedbackInput && (
          <FormGroup className='ml-0 mt-2'>
            <Input
              id='feedback'
              name='feedback'
              placeholder='Feedback'
              type='textarea'
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              rows={3}
            />
          </FormGroup>
        )}
        {!showFeedbackInput ? (
          <div
            className='d-flex w-100 justify-content-center mt-5'
            style={{ gap: '1rem' }}
          >
            <button
              className='btn btn-success'
              onClick={() => {
                dispatch(
                  giveCompletionFeedback(courseId, {
                    understood: 1,
                    feedback: null,
                  })
                )

                setShowModal(false)
              }}
            >
              Yes
            </button>
            <button
              className='btn btn-danger'
              onClick={() => setShowFeedbackInput(true)}
            >
              No
            </button>
          </div>
        ) : (
          <button
            className='btn btn-success'
            onClick={() => {
              if (!feedback.trim()) {
                setErrorMessage(true)
                return
              }

              dispatch(
                giveCompletionFeedback(courseId, {
                  understood: 0,
                  feedback,
                })
              )

              setShowModal(false)
            }}
          >
            Submit Feedback
          </button>
        )}
      </ModalBody>
    </Modal>
  )
}

export default CompletionFeedbackModal
